import React, { useEffect, useState, useCallback } from "react";
import "../../gamble.css";
import QRCode from "../../QRCodeGenerator.js";

const BACKEND = "https://garettobackend.onrender.com";

const short1 = (addr) =>
  addr ? `${addr.slice(0, 10)}...${addr.slice(-10)}` : "-";
const short2 = (addr) =>
  addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : "-";
const addressLink = (addr) => `https://polygonscan.com/address/${addr}`;

const TokenLogo = ({ size = 12 }) => (
  <img
    src="/logo.svg"
    alt="token logo"
    style={{ width: `${size}px`, verticalAlign: "middle", marginLeft: "3px" }}
  />
);

export default function Gamble1Base() {
  const [tournaments, setTournaments] = useState([]);
  const [price, setPrice] = useState(null);
  const [isQRCodeVisible, setIsQRCodeVisible] = useState(false);
  const [currentQRCodeData, setCurrentQRCodeData] = useState("");
  const [copied, setCopied] = useState(false);

  const copy = async (address) => {
    await navigator.clipboard.writeText(address);
    setCopied(address);
    setTimeout(() => setCopied(false), 1200);
  };

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND}/api/polygon/tournaments`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setTournaments(data.filter((t) => t.winners === 2));
      }
    } catch (e) {
      console.warn("Gamble1Base fetch failed", e);
    }
  }, []);

  const fetchPrice = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND}/api/price`);
      const data = await res.json();
      if (data.price_usd) setPrice(data.price_usd);
    } catch (e) {
      console.warn("Price fetch failed", e);
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchPrice();
    const t1 = setInterval(fetchData, 10000);
    const t2 = setInterval(fetchPrice, 30000);
    return () => {
      clearInterval(t1);
      clearInterval(t2);
    };
  }, [fetchData, fetchPrice]);

  const renderTournament = (t) => {
    const { state, players, previous_cycles: previousCycles } = t;
    const EXPLORER = `https://polygonscan.com/address/${t.address}`;
    const primaryBetUsd = price
      ? `$${(Number(t.bet_display) * Number(price)).toFixed(6)}`
      : "Loading...";
    const poolUsd = price
      ? (t.estimated_pool * Number(price)).toFixed(6)
      : null;

    return (
      <div className="gamble-wrapper" key={t.id}>
        <div className="gamble-content1">
          <div className="gambleRow">
            <h5>{t.label}</h5>
          </div>
          <div className="gamble-content12">
            <h5>
              {t.bet_display}
              <TokenLogo size={15} /> = {primaryBetUsd}
            </h5>
            <div className="gambleRow">
              <a
                href={EXPLORER}
                target="_blank"
                rel="noopener noreferrer"
                className="address-link"
              >
                <div className="gambleRow">{t.address}</div>
              </a>
            </div>
            <div className="headerButtonRow">
              {copied === t.address && (
                <span className="copy-msg-inline">Copied</span>
              )}
              <button
                onClick={() => copy(t.address)}
                className="copyButton"
                title="Copy address"
              >
                📋
              </button>
              <button
                onClick={() => {
                  setCurrentQRCodeData(t.address);
                  setIsQRCodeVisible(true);
                }}
                className="copyButton"
              >
                🔳
              </button>
            </div>
            {isQRCodeVisible && currentQRCodeData === t.address && (
              <div className="qr-code-modal">
                <div className="qr-code-container">
                  <h6 style={{ color: "black" }}>{t.address}</h6>
                  <div className="gettoHeaderRowSub">
                    <p>
                      To join the tournament you just need to send{" "}
                      {t.bet_display} <TokenLogo /> to the contract address.
                    </p>
                  </div>
                  <QRCode address={t.address} id={`qr-${t.address}`} />
                  <button
                    onClick={() => {
                      setIsQRCodeVisible(false);
                      setCurrentQRCodeData("");
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="gamble-content11">
            {state ? (
              <>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>Cycle:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5>{state.cycle_id}</h5>
                  </div>
                </div>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>Winners:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5>{t.winners}</h5>
                  </div>
                </div>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>Players:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5>
                      {state.count} / {state.max}
                    </h5>
                  </div>
                </div>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>to JOIN:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5>
                      send {t.bet_display}
                      <TokenLogo size={16} />
                    </h5>
                  </div>
                </div>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>Actual Bet:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5>
                      {t.actual_bet}
                      <TokenLogo size={16} />
                    </h5>
                  </div>
                </div>
                <div className="gambleHeaderRow">
                  <div className="gambleRow">
                    <h6>Pool:</h6>
                  </div>
                  <div className="gettoHeaderRowSub">
                    <h5
                      title={
                        poolUsd
                          ? `Estimated Pool USD Value: $${poolUsd}`
                          : "Loading..."
                      }
                      style={{ cursor: "help" }}
                    >
                      {state.pool} / {t.estimated_pool}
                      <TokenLogo size={16} />
                    </h5>
                  </div>
                </div>
              </>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>

        <div className="gamble-content1112">
          <div className="gambleCenteredRowHeader">
            <h5>Current Players</h5>
          </div>
          <div className="gamble-content123">
            <div className="gambleList">
              {(!players || players.length === 0) && <p>No players yet</p>}
              {players &&
                players.map((p, i) => (
                  <div className="gambleRow" key={p}>
                    <p>
                      {i + 1}:{" "}
                      <a
                        href={addressLink(p)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="address-link"
                      >
                        {short1(p)}
                      </a>
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="gamble-content1112">
          <div className="gambleCenteredRowHeader">
            <h5>Previous Cycles</h5>
          </div>
          <div className="gamble-content111">
            {(!previousCycles || previousCycles.length === 0) && (
              <div className="gamblePlaceholder">
                <p>No previous cycles found</p>
              </div>
            )}
            {previousCycles &&
              previousCycles.map((cycle) => (
                <div
                  key={cycle.id}
                  className="gambleBlock"
                  style={{ marginBottom: "25px" }}
                >
                  <div className="gambleCenteredRow">
                    <h5>CYCLE #{cycle.id}</h5>
                  </div>

                  {/* TWO WINNERS */}
                  {cycle.champion && (
                    <>
                      <div className="gambleHeaderRow">
                        <div className="gambleRow">
                          <h5>1st Place:</h5>
                        </div>
                        <div className="gettoHeaderRowSub">
                          <a
                            href={addressLink(cycle.champion)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="address-link"
                          >
                            {short2(cycle.champion)}
                          </a>
                        </div>
                      </div>
                      <div className="gambleHeaderRow">
                        <div className="gambleRow">
                          <h5>1st Place Prize:</h5>
                        </div>
                        <div className="gettoHeaderRowSub">
                          <p>
                            {cycle.champion_prize} <TokenLogo size={16} />
                          </p>
                        </div>
                      </div>
                      <div className="gambleHeaderRow">
                        <div className="gambleRow">
                          <h5>2nd Place:</h5>
                        </div>
                        <div className="gettoHeaderRowSub">
                          <a
                            href={addressLink(cycle.runner_up)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="address-link"
                          >
                            {short2(cycle.runner_up)}
                          </a>
                        </div>
                      </div>
                      <div className="gambleHeaderRow">
                        <div className="gambleRow">
                          <h5>2nd Place Prize:</h5>
                        </div>
                        <div className="gettoHeaderRowSub">
                          <p>
                            {cycle.runner_up_prize} <TokenLogo size={16} />
                          </p>
                        </div>
                      </div>
                    </>
                  )}

                  {cycle.rounds &&
                    Object.entries(cycle.rounds)
                      .sort((a, b) => Number(a[0]) - Number(b[0]))
                      .map(([step, round]) => (
                        <div key={`${cycle.id}-${step}`}>
                          <div className="gambleRow">
                            <h5>Step {step}</h5>
                          </div>
                          {round.winners &&
                            round.winners.map((w, i) => {
                              const l = round.losers[i];
                              return (
                                <div
                                  className="gambleRow"
                                  key={`${cycle.id}-${step}-${i}`}
                                >
                                  <p>
                                    <a
                                      href={addressLink(w)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="address-link"
                                    >
                                      {short2(w)}
                                    </a>{" "}
                                    (W) -{" "}
                                    <a
                                      href={addressLink(l)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="address-link"
                                    >
                                      {short2(l)}
                                    </a>{" "}
                                    (L)
                                  </p>
                                </div>
                              );
                            })}
                        </div>
                      ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="gamble-container">
      <div className="about-block">
        <div className="global-content2">
          <h4>3 STEP / 8 PLAYERS TOURNAMENT SMART CONTRACTS WITH 2 WINNERS</h4>
          <p>
            The 3 step tournament consists of 8 players. To take part in
            tournament each player sends the exact bet amount to the smart
            contracts address, it receives minus 0.1%. Then 6.9% will be
            deducted to cover costs and ensure a profit, the rest will be added
            to the pot, and the players address will be automatically added to
            the players list. Whenever the last player joins, the contract will
            automatically determine the winner by getting random numbers from
            Chainlink VRF, shuffling the players list and sending the pot to the
            winners address. The first place address will receive 70% of the
            pot, second place 30%.
          </p>
        </div>
      </div>
      {tournaments.map((t) => renderTournament(t))}
    </div>
  );
}
